const staticSource = (sourceName) => process.env.REACT_APP_STATIC_URL + sourceName;

export default staticSource;
